module.exports = __webpack_public_path__ + "fonts/9df5f782-d089-4356-8fc5-8f4a338019c8.2202a227.woff";